/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Self_Organize_Not_Open_RoundsInputs */



/**
* | output |
* | --- |
* | "Self-organized rounds require an open-rounds tournament" |
*
* @param {Err_Tournament_Self_Organize_Not_Open_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_self_organize_not_open_rounds = /** @type {((inputs?: Err_Tournament_Self_Organize_Not_Open_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Self_Organize_Not_Open_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les rondes auto-organisées nécessitent un tournoi à rondes ouvertes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las rondas autoorganizadas requieren un torneo de rondas abiertas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As rodadas auto-organizadas requerem um torneio de rodadas abertas")
	if (locale === "it") return /** @type {LocalizedString} */ ("I round autogestiti richiedono un torneo con round aperti")
	return /** @type {LocalizedString} */ ("Self-organized rounds require an open-rounds tournament")
});